import React from 'react';

import { Row, Tab, Spacer } from './styled';

interface GraphFilterProps {
  activeTime: string;
  setActiveTime: (time: string) => void;
  chartType: string;
  setChartType: (type: string) => void;
}

const TIMEFRAMES = ['1s', '1m', '5m', '15m', '30m', '1h', '4h'] as const;

const GraphFilter = ({
  activeTime,
  setActiveTime,
  chartType,
  setChartType,
}: GraphFilterProps) => {
  return (
    <Row>
      {TIMEFRAMES.map((t) => (
        <Tab
          key={t}
          type="button"
          className={t === activeTime ? 'on' : ''}
          onClick={() => setActiveTime(t)}
        >
          {t}
        </Tab>
      ))}
      <Spacer />
      <Tab
        type="button"
        className={chartType === 'Candles' ? 'on' : ''}
        onClick={() => setChartType('Candles')}
      >
        Candle
      </Tab>
      <Tab
        type="button"
        className={chartType === 'Line' ? 'on' : ''}
        onClick={() => setChartType('Line')}
      >
        Line
      </Tab>
    </Row>
  );
};

export default GraphFilter;
